import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { StorageService } from "../services/storage.service";

interface PermisoRuta {
    nivel: number;
    url: string;
}

@Injectable({
    providedIn:'root'
})

export class RutasGuard implements CanActivate{

    ruta: string = "";
    rutasBasePermitidas = [
        '/',
        '/perfil',
        '/mantenedores/tipo-carga',
        '/mantenedores/tipo-combustion',
        '/mantenedores/tipos-trabajo',
        '/mantenedores/tipos-vehiculo',
        '/mantenedores/tipos-traccion',
        '/mantenedores/flota',
        '/seguridad/tipos-usuario',
        '/seguridad/usuarios',
        '/seguridad/roles',
        '/seguridad/permisos',
        '/reportes/solicitudes',
        '/reportes/valoraciones',
        '/reportes/usuarios',
        '/reportes/vehiculos',
        '/reportes/monitoreo',
    ];

    constructor(
        private storageService:StorageService,
           private router:Router
    ){
        
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {

        this.ruta = state.url.startsWith('/') ? state.url : '/' + state.url;
        const permisos = this.storageService.storageGet<PermisoRuta[]>('permisos');
        const listaPermisos = Array.isArray(permisos) ? permisos : [];

        if(this.rutasBasePermitidas.includes(this.ruta)){
            return true;
        }

        if(this.ruta != '/'){
            const acceso = listaPermisos.find((i) => i.nivel === 4 && i.url === this.ruta);

            if(acceso == undefined){
                this.router.navigate(['/'])
                return false;
            }
        }

        return true;
        
    }
}
